import React, { useMemo } from 'react';

import DayJs from 'utils/Dayjs';
import { secondsToParts } from 'utils/Helpers';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import { Button } from 'components/Misc/Form';
import { Title, Mark } from 'components/Misc/Typography';

const Take = ({ take }) => {
	// Check if take is missed
	const isMissed = false;

	// Calculate how many seconds did exam take
	const seconds = useMemo(() => DayJs(take.endedAt).diff(take.startedAt, 's'), [take]);

	// Get exam's duration in usable format
	const duration = useMemo(() => secondsToParts(seconds), [seconds]);

	return (
		<div className="table-row">
			<div className="pl-2 table-cell h-14 w-14 text-center align-middle">
				<Avatar
					alt={take.student.fullName}
					src={take.student.avatar}
					online={take.student.online}
				/>
			</div>
			
			<div className="px-2 table-cell align-middle">
				<Title title={take.student.fullName} />
			</div>
			
			<div className="px-2 table-cell align-middle">
				<Title subtitle={take.exam.subject.title} />
			</div>

			<div className="px-2 table-cell align-middle">
				<Title subtitle={take.exam.course.title} />
			</div>

			<div className="px-2 table-cell text-white align-middle">
				<Show if={take.startedAt}>
					<Title subtitle={DayJs(take.startedAt).format('D. MMM, YYYY HH:mm')} />
				</Show>
			</div>

			{/* <div className="px-2 table-cell align-middle">
				<Show if={take.state === 'finished'}>
					<Pill
						name={`${duration.days}d : ${duration.hours}h : ${duration.minutes}m : ${duration.seconds}s`}
					/>
				</Show>
			</div> */}

			<div className="px-2 table-cell align-middle text-right">
				<Show if={take.state === 'reviewed'}>
					<Mark mark={take.mark} />
				</Show>
			</div>

			<div className="px-2 pr-4 w-7 table-cell align-middle text-right">
				<Button
					small
					square
					icon="link"
					to={`/exams/results/review/${take.examId}/${take.id}`}
				/>
			</div>
		</div>
	);
};

export default Take;